import { getAuthTokenAsync } from "src/store/common";
import { User, Meta } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: User[];
  meta: Meta;
}

export enum UserFilterType {
  ALL = "all",
  MEMBERS = "members",
  SERVICE_PROVIDERS = "serviceProviders",
}

// fetch user list
export const fetchUserList = async (data: {
  page: number;
  limit: number;
  search?: string;
  userFilterType?: UserFilterType;
  userStatus?: string;
}): Promise<ApiResponse> => {
  const params: Record<string, string | number> = {
    page: data.page,
    limit: data.limit,
  };

  if (data.userFilterType) {
    params.userFilterType = data.userFilterType;
  }

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  if (data.userStatus) {
    params.userStatus = data.userStatus;
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/user/all-users`,
    params,
  );
  return response;
};

// ban/unban user
export const banUnbanUser = (uid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/user/toggle-ban/${uid}`,
  );
};
